import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(pages)/(main)/(text)/page.tsx");
